import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const Subtitulo = props => {
    const classes = useStyles();
  
    return (
      <Grid item xs={12} className={classes.gridSubtitulo}>
        <Typography variant='h6' className={classes.subtitulo}>
          {props.subtitulo}
        </Typography>
      </Grid>
    )
  }
  
  const useStyles = makeStyles({
    subtitulo: {
      fontWeight: 'bold',
      color: '#23144D',
      fontSize: '13pt'
    },
    gridSubtitulo: {
      paddingTop: '0px !important'
    }
  });
  
  export default Subtitulo;